<div class="page-container reserve-confirm-content">
  <!--title 標題-->
  <div class="page-title-block">
    <h2 class="page-title">{{ 'appointment-time.title' | translate }}</h2>
    <div class="page-subtitle-block">
      <img width="26" height="26" ngSrc="assets/img/i-clock-user.svg" alt="clock-user" />
      <div>
        <p class="page-subtitle-block-title">
          {{
          'appointment-time.hint-title' | translate: { dayType: dayTypeText }
          }}
          {{
          dayType === API_PARAMS.DAY_TYPE.FULL_DAY.code
          ? ('appointment-time.hint-title-hours'
          | translate: { hours: FULL_DAY_CHECKUP_HOURS })
          : ''
          }}
        </p>
        <p>{{ 'appointment-time.hint-message' | translate }}</p>
      </div>
    </div>
  </div>

  <!--健康檢查時間-->
  <div class="card-content register-card-content active">
    <h3 class="register-card-title">
      <span>{{ 'appointment-time.health-check' | translate }}</span>
      {{ 'appointment-time.select-date-and-time' | translate }}
    </h3>
    @if (showError && (!selectedBookingDate || !selectedBookingTime)) {
    <div class="input-block">
      <mat-error class="input-error-msg">{{
        'error.date-time-error.required' | translate
        }}</mat-error>
    </div>
    }
    @if (bookCalInfos.length > 0) {
    <div class="input-block appointment-calendar-block">
      <div class="calendar-header">
        <button mat-button class="btn-icon" [disabled]="isPrevDisabled()" (click)="prevMonth()">
          <img src="assets/img/i-arrow-left.svg" alt="" />
        </button>
        <span class="calendar-year">{{
          startOfFirstMonth | date: 'MM 月 yyyy'
          }}</span>
        <span class="calendar-year">{{
          startOfSecondMonth | date: 'MM 月 yyyy'
          }}</span>
        <button mat-button class="btn-icon" [disabled]="isNextDisabled()" (click)="nextMonth()">
          <img src="assets/img/i-arrow-right.svg" alt="" />
        </button>
      </div>
      <div class="calendar-body" #fieldRef [attr.data-control-name]="'bookingCalendar'">
        @if (showCalendar1) {
        <mat-calendar ngSkipHydration [startAt]="startOfFirstMonth" [selected]="selectedBookingCalendar"
          [dateClass]="bookingDateClass" [dateFilter]="bookingDateFilter" (selectedChange)="selectBookingDate($event)"
          [minDate]="minDate" [maxDate]="maxDate">
        </mat-calendar>
        }
        @if (showCalendar2) {
        <mat-calendar ngSkipHydration [startAt]="startOfSecondMonth" [selected]="selectedBookingCalendar"
          [dateClass]="bookingDateClass" [dateFilter]="bookingDateFilter" (selectedChange)="selectBookingDate($event)"
          [minDate]="minDate" [maxDate]="maxDate">
        </mat-calendar>
        }
      </div>
    </div>
    <div class="input-block input-warn-msg input-calendar-msg">
      <img width="16" height="16" ngSrc="/assets/img/i-calendar-s.svg" alt="" />
      <span>{{ 'appointment-time.only-one-or-two-left' | translate }}</span>
    </div>
    @if(orgInfoText.length > 0) {
    <div class="input-block input-warn-msg-box">
      <div class="input-warn-msg" style="padding: 0px;">
        <img width="16" height="16" ngSrc="/assets/img/i-warn-outline.svg" alt="" />
        <span>若您當天檢查項目含:</span>
      </div>
      <div style="padding: 0 20px 0 30px;">
        @for(item of orgInfoText ; track $index){
        <div class="input-warn-msg" style="padding: 0px;">
          <span>{{ item }}</span>
        </div>
        }
      </div>
    </div>
    }
    @if (selectedBookingDate && selectedBookingDate.bookTimes && selectedBookingDate.bookTimes.length > 0) {
    <div class="input-block">
      <label class="input-title">{{
        'appointment-time.check-in-time' | translate
        }}</label>
      <div class="btn-chips-block">
        @for (time of selectedBookingDate.bookTimes; track $index) {
        <button mat-button class="btn-chips" (click)="selectBookingTime(time)"
          [ngClass]="{ active: selectedBookingTime === time }">
          {{ time | slice: 0 : 2 }}:{{ time | slice: 2 }}
        </button>
        }
      </div>
    </div>
    }
    }
  </div>

  <!--營養諮詢時間-->
  @if (nutCalInfos && nutCalInfos.length > 0) {
  <div class="card-content register-card-content" [ngClass]="{ active: selectedBookingDate && selectedBookingTime }">
    <h3 class="register-card-title">
      <span>{{ 'appointment-time.nutritional-consultation' | translate }}</span>
      {{ 'appointment-time.select-date-and-time' | translate }}
    </h3>
    @if (showError && (!selectedNutBookingDate || !selectedNutBookingTime)) {
    <div class="input-block">
      <mat-error class="input-error-msg">{{
        'error.date-time-error.required' | translate
        }}</mat-error>
    </div>
    }
    <div class="input-block appointment-calendar-block">
      <div class="calendar-header">
        <button mat-button class="btn-icon" [disabled]="isPrevDisabled()" (click)="prevMonth()">
          <img src="assets/img/i-arrow-left.svg" alt="" />
        </button>
        <span class="calendar-year">{{
          startOfFirstMonth | date: 'MM 月 yyyy'
          }}</span>
        <span class="calendar-year">{{
          startOfSecondMonth | date: 'MM 月 yyyy'
          }}</span>
        <button mat-button class="btn-icon" [disabled]="isNextDisabled()" (click)="nextMonth()">
          <img src="assets/img/i-arrow-right.svg" alt="" />
        </button>
      </div>
      <div class="calendar-body" #fieldRef [attr.data-control-name]="'nutBookingCalendar'">
        @if (showCalendar1) {
        <mat-calendar ngSkipHydration [startAt]="startOfFirstMonth" [dateClass]="nutBookingDateClass"
          [dateFilter]="nutBookingDateFilter" [selected]="selectedNutBookingCalendar"
          (selectedChange)="selectNutBookingDate($event)" [minDate]="minDate" [maxDate]="maxDate"></mat-calendar>
        }
        @if (showCalendar2) {
        <mat-calendar ngSkipHydration [startAt]="startOfSecondMonth" [dateClass]="nutBookingDateClass"
          [dateFilter]="nutBookingDateFilter" [selected]="selectedNutBookingCalendar"
          (selectedChange)="selectNutBookingDate($event)" [minDate]="minDate" [maxDate]="maxDate"></mat-calendar>
        }
      </div>
    </div>
    <div class="input-block input-warn-msg input-calendar-msg">
      <img width="16" height="16" ngSrc="/assets/img/i-calendar-s.svg" alt="" />
      <span>{{ 'appointment-time.only-one-or-two-left' | translate }}</span>
    </div>
    @if (selectedNutBookingDate) {
    <div class="input-block">
      <label class="input-title">{{
        'appointment-time.check-in-time' | translate
        }}</label>
      <div class="btn-chips-block">
        @for (time of selectedNutBookingDate.nutBookTimes; track $index) {
        <button mat-button class="btn-chips" (click)="selectNutBookingTime(time)"
          [ngClass]="{ active: selectedNutBookingTime === time }">
          {{ time | slice: 0 : 2 }}:{{ time | slice: 2 }}
        </button>
        }
      </div>
    </div>

    }
  </div>

  }
  <!-- <div style="width:100%;display: flex;justify-content: flex-end;">
    <mat-checkbox [(ngModel)]="sunDayAppoint" (change)="onSunDayAppointChange($event)">
      找不到合適的日期?請專人聯絡我
    </mat-checkbox>
  </div> -->
  <div class="reservation-notice-container">
    <h3 class="notice-title">各季檢查於 2 個月前第一個工作天 08:30 開放預約</h3>

    <div class="notice-list-wrapper">
      <ul class="notice-list">
        <li>2 月起開放 4 ~ 6 月的檢查</li>
        <li>8 月起開放 10 ~ 12 月的檢查</li>
      </ul>
      <ul class="notice-list">
        <li>5 月起開放 7 ~ 9 月的檢查</li>
        <li>11 月起開放隔年 1 ~ 3 月的檢查</li>
      </ul>
    </div>
  </div>
  <!--  選擇聯繫時間-->
  @if (imageCalInfo) {
  <div class="card-content register-card-content active">
    <h3 class="register-card-title subtitle-item">
      {{ 'appointment-time.image-info-title' | translate }}
    </h3>
    @if (imageItemNames.length > 0) {
    <div class="input-block image-subtitle">
      <span class="register-card-subtitle" style="font-size: 16px;">{{ 'appointment-time.image-item-include' | translate
        }}
        {{ imageItemNames }}</span>
    </div>

    }
    <div class="input-block" #fieldRef [attr.data-control-name]="'contactNumber'">
      <label class="input-title">{{
        'appointment-time.contact-number' | translate
        }}</label>
      <input matInput [formControl]="contactNumberControl" [maxlength]="contactNumberMaxLength" [placeholder]="
            'appointment-time.contact-number-placeholder' | translate
          " [ngClass]="{
            'input-error': showError && contactNumberControl.invalid,
          }" />
      @if (showError && contactNumberControl.invalid) {
      <mat-error class="input-error-msg">{{
        getPhoneErrorMessage()
        }}</mat-error>
      }

      <div class="input-warn-msg-box">
        <div class="input-warn-msg flex-top">
          <img width="16" height="16" ngSrc="/assets/img/i-warn-outline.svg" alt="" />
          <span>{{ 'appointment-time.image-info-hint3' | translate }}</span>
        </div>
        <div class="input-warn-msg flex-top">
          <img width="16" height="16" ngSrc="/assets/img/i-warn-outline.svg" alt="" />
          <span>{{ 'appointment-time.image-info-hint4' | translate }}</span>
        </div>
        <div class="input-warn-msg flex-top">
          <img width="16" height="16" ngSrc="/assets/img/i-warn-outline.svg" alt="" />
          <span>{{ 'appointment-time.image-info-hint5' | translate }}</span>
        </div>
      </div>
    </div>

  </div>

  }

  <!--固定按鈕區塊-->
  <div class="page-btn-block">
    <button mat-button (click)="previous()" class="btn-outline-primary btn-size-l">
      @if (modifyType === 'modifyTime') {
      {{ 'common.button.cancel' | translate }}
      } @else {
      {{ 'common.button.previous' | translate }}
      }
    </button>
    <button mat-button (click)="confirm()" class="btn-fill-primary btn-size-l">
      {{ 'appointment-time.button-check-time' | translate }}
    </button>
  </div>
</div>